module.exports = __webpack_public_path__ + "static/media/image_instagram.00be18f3.png";